import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";

export const fetchToken = createAsyncThunk(
    'authentication/fetchToken',
    async ({ email_id }, { rejectWithValue }) => {
        try {
            const response = await axiosNoAuth.post(
                `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/auth/token`,
                { email: email_id }
            );
            return {
                ...response.data,
                uid: response.data.user_id,
                user_name: response.data.name,
                user_phone: response.data.phone,
            };
        } catch (err) {
            return rejectWithValue({
                detail: err.response?.data?.detail || 'Unable to authenticate. Please try again.',
                status: err.response?.status,
            });
        }
    }
);

export const getUserRole = createAsyncThunk(
    'getUserRole',
    async ({ email }) => {
        try {
            const response = await axiosNoAuth.get(`https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user/check_core_platform_role?email=${email}`)
            return response.data
        } catch (error) {
            console.log(error.message)
            throw error;
        }
    }
)

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState: {
        email: '',
        userName: '',
        userPhone: '',
        token: null,
        tokenExpiresAt: null,
        userId: null,
        uid: null,
        error: null,
        userRole: {
            user_role: 0,
            role_type: ''
        }
    },
    reducers: {
        logoutUser(state) {
            state.token = null;
            state.tokenExpiresAt = null;
            state.userId = null;
            state.uid = null;
        },
        setUserEmail(state, action) {
            state.email = action.payload;
        },
        setAuthenticationError(state, action) {
            state.error = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchToken.pending, (state) => {
            state.error = null;
        })
        .addCase(fetchToken.fulfilled, (state, action) => {
            state.uid = action.payload.user_id;
            state.userId = action.payload.user_id;
            state.token = action.payload.access_token;
            state.tokenExpiresAt = action.payload.access_expires_at;
            state.userName = action.payload.name;
            state.userPhone = action.payload.phone;
            state.profileComplete = action.payload.profile_complete;
            state.role = action.payload.role;
            state.error = null;
        })
        .addCase(fetchToken.rejected, (state, action) => {
            state.error = action.payload?.detail || action.error?.message || 'Unable to authenticate.';
        })
        .addCase(getUserRole.fulfilled, (state, action) => {
            state.userRole = action.payload
        })
    },
});

export const { logoutUser, setUserEmail, setAuthenticationError } = authenticationSlice.actions
export const selectAuthentication = (state) => state.authentication;
export default authenticationSlice.reducer;
